import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createMatOutwardEntry = createAsyncThunk('createMatOutwardEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertMaterialOutWard`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const updateMatOutwardEntry = createAsyncThunk('updateMatOutwardEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=updateMaterialOutward`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMatStockData = createAsyncThunk('fetchMatStockData', async (id) => {
    try {
        // const response = await axios.get(`${baseUrl}?apicall=getMaterialStockList`);
        const endpoint = id ? `getMaterialStockBarcodeReglist&barcode=${id}` : `getMaterialStockBarcodeReglist`;
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const fetchMarerialInwardView = createAsyncThunk(
    'fetchMarerialInwardView',
    async ({ inwardNo, inwardType }) => {
        const response = await axios.get(
            `${baseUrl}?apicall=getMaterialInwardView&inwardNo=${inwardNo}&inwardType=${inwardType}`
        );
        return response.data;
    }
);



export const fetchSingleMatStock = createAsyncThunk('fetchSingleMatStock', async (id) => {
    try {
        // console.log("id=>", id);
        const response = await axios.get(`${baseUrl}?apicall=getMaterialStockList&matOutId=${id}`);
        // console.log("api response data=>", response.data);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const deleteSingleMatOutward = createAsyncThunk('deleteSingleMatOutward', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteMaterialOutward&matOutId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchMatOutwardStkValue = createAsyncThunk('fetchMatOutwardStkValue', async (id) => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getMaterialOutwardList&matId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const matStockSlice = createSlice({
    name: 'MatStockData',
    initialState: {
        isLoading: false,
        matStock: null,
        deleteMatOutward: null,
        singleMatStock: null,
        materialInwardView: null,
        stkValue: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchMatStockData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMatStockData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.matStock = action.payload;
        });
        builder.addCase(fetchMatStockData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSingleMatOutward.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSingleMatOutward.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deleteMatOutward = action.payload;
        });
        builder.addCase(deleteSingleMatOutward.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


        builder.addCase(fetchSingleMatStock.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchSingleMatStock.fulfilled, (state, action) => {
            state.isLoading = false;
            state.singleMatStock = action.payload;
        });
        builder.addCase(fetchSingleMatStock.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
        builder.addCase(fetchMarerialInwardView.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMarerialInwardView.fulfilled, (state, action) => {
            state.isLoading = false;
            state.materialInwardView = action.payload;
        });
        builder.addCase(fetchMarerialInwardView.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchMatOutwardStkValue.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchMatOutwardStkValue.fulfilled, (state, action) => {
            state.isLoading = false;
            state.stkValue = action.payload;
        });
        builder.addCase(fetchMatOutwardStkValue.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });


    }
});

export default matStockSlice.reducer;
